import { IIndividual } from "../../types/individual";
import Tabs, { Tab } from "../common/tabs/tabs";
import { fullNameAutoFormat } from "../../utils/format-fullname";
import { IOrg } from "../../types/org";
import IndividualDetails from "./individual-details/individual-details";
import { IPosition } from "../../types/position";
import { Card, CardBody, CardTitle } from "reactstrap";
import IndividualDigitalAddress from "./individual-digital-address/individual-digital-address";
import { useEffect, useState } from "react";
import useAuth from "../../hook/useAuth";
import useTopCoordinator from "../../hook/useTopCoordinator";

type IndividualProps = {
  org: IOrg|undefined,
  position: IPosition | undefined,
  individual: IIndividual
}

const Individual = (props: IndividualProps) => {
  const { org, individual, position } = props;
  const [fullName,setFullName] = useState<string>();
  const [readOnly,setReadOnly] = useState<boolean>(false); 
  const [cloned,setCloned] = useState<boolean>(false);
  const { isAdmin } = useAuth();
  const isTopCoordinator  = useTopCoordinator(org?.id||0);

  useEffect(()=>{
    setCloned(!!position?.shareLinkId)
  },[position])

  useEffect(() => {
    if (isAdmin) {
      setReadOnly(false);
    } else if (isTopCoordinator && cloned) {
      setReadOnly(false);
    } else if (!isTopCoordinator && cloned) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [isTopCoordinator, isAdmin, cloned]);
  

  useEffect(()=>{
    setFullName(fullNameAutoFormat(individual?.firstName, individual?.middleName, individual?.lastName))
  },[individual])

  const onNameUpdate = (fullName:string) => {
    setFullName(fullName)
  }


  const tabs: Tab[] = [
    { title: 'Individual Details', content: <IndividualDetails org={org} position={position} individual={individual} onNameUpdate={onNameUpdate} orgReadOnly={readOnly}/> },
    { title: 'Email Addresses', content: <IndividualDigitalAddress individualId={individual.individualId } orgReadOnly={readOnly}/> },
  ];

  return (
    <Card aria-label="Individual Information">
      <CardBody>
        <CardTitle>
          Individual: {fullName}
        </CardTitle>

        <Tabs tabs={tabs} />
      </CardBody>
    </Card>
  );
}

export default Individual;
